import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./grid.html";
export let GridAxis = /*#__PURE__*/function (GridAxis) {
  GridAxis["Row"] = "row";
  GridAxis["RowReverse"] = "row-reverse";
  GridAxis["Column"] = "column";
  GridAxis["ColumnReverse"] = "column-reverse";
  return GridAxis;
}({});
export let GridFlows = /*#__PURE__*/function (GridFlows) {
  GridFlows["Wrap"] = "wrap";
  GridFlows["Unset"] = "unset";
  return GridFlows;
}({});
export let GridGapSizes = /*#__PURE__*/function (GridGapSizes) {
  GridGapSizes["XxxSmall"] = "xxx-small";
  GridGapSizes["XxSmall"] = "xx-small";
  GridGapSizes["XSmall"] = "x-small";
  GridGapSizes["Small"] = "small";
  GridGapSizes["Medium"] = "medium";
  GridGapSizes["Large"] = "large";
  GridGapSizes["XLarge"] = "x-large";
  GridGapSizes["XxLarge"] = "xx-large";
  return GridGapSizes;
}({});
export let GridAlignItems = /*#__PURE__*/function (GridAlignItems) {
  GridAlignItems["Start"] = "start";
  GridAlignItems["End"] = "end";
  GridAlignItems["Center"] = "center";
  GridAlignItems["Space"] = "space";
  GridAlignItems["Spread"] = "spread";
  return GridAlignItems;
}({});
export let GridFlexs = /*#__PURE__*/function (GridFlexs) {
  GridFlexs["None"] = "none";
  GridFlexs["Grow"] = "grow";
  GridFlexs["Shrink"] = "shrink ";
  return GridFlexs;
}({});
class Grid extends LightningElement {
  set gridAxis(value) {
    this.setAttribute('axis', value);
  }
  get gridAxis() {
    return this.getAttribute('axis');
  }
  set gridFlow(value) {
    this.setAttribute('flow', value);
  }
  get gridFlow() {
    return this.getAttribute('flow');
  }
  set gridGap(value) {
    this.setAttribute('gap', value);
  }
  get gridGap() {
    return this.getAttribute('gap');
  }
  set gridRowGap(value) {
    this.setAttribute('row-gap', value);
  }
  get gridRowGap() {
    return this.getAttribute('row-gap');
  }
  set gridFlex(value) {
    this.setAttribute('flex', value);
  }
  get gridFlex() {
    return this.getAttribute('flex');
  }
  set gridAlignItems(value) {
    this.setAttribute('align-items', value);
  }
  get gridAlignItems() {
    return this.getAttribute('align-items');
  }
  connectedCallback() {
    this.setAttribute('grid', '');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Grid, {
  publicProps: {
    gridAxis: {
      config: 3
    },
    gridFlow: {
      config: 3
    },
    gridGap: {
      config: 3
    },
    gridRowGap: {
      config: 3
    },
    gridFlex: {
      config: 3
    },
    gridAlignItems: {
      config: 3
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Grid, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;